'use strict';
/* Zizara UK — JS */

window.ZizEntrega = {
  calc: function(dias) {
    dias = dias || 10;
    var now  = new Date();
    var bstH = now.getUTCHours() + 1;
    var d    = new Date(now);
    d.setDate(d.getDate() + dias);
    var dn = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var mn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var envioMsg;
    if (bstH < 12)      { envioMsg = 'Ships today'; }
    else if (bstH < 18) { envioMsg = 'Ships within 1 hour'; }
    else                { envioMsg = 'Ships tomorrow morning'; }
    return {
      chegada: dn[d.getDay()] + ' ' + d.getDate() + ' ' + mn[d.getMonth()],
      envio:   envioMsg
    };
  },
  init: function() {
    var self = this;
    function run() {
      var r = self.calc(10);
      document.querySelectorAll('[data-ab-entrega]').forEach(function(el) {
        el.textContent = r.chegada;
      });
      document.querySelectorAll('[data-entrega-envio]').forEach(function(el) {
        el.textContent = r.envio;
      });
      document.querySelectorAll('[data-entrega-dias]').forEach(function(el) {
        if (el.dataset.ok) return;
        el.dataset.ok = '1';
        var de = el.querySelector('[data-entrega-data]');
        var ce = el.querySelector('[data-entrega-corte]');
        if (de) de.textContent = r.chegada;
        if (ce) ce.textContent = r.envio;
      });
    }
    run();
    setInterval(function() {
      document.querySelectorAll('[data-entrega-dias]').forEach(function(el) {
        delete el.dataset.ok;
      });
      run();
    }, 300000);
  }
};

window.ZizHeader = {
  init: function() {
    var h = document.getElementById('hdr');
    if (!h) return;
    var last = 0;
    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      h.classList.toggle('rolado', y > 50);
      if (y > last + 6 && y > 180) h.classList.add('oculto');
      else if (y < last - 6)       h.classList.remove('oculto');
      last = y;
    }, { passive: true });
  }
};

window.ZizNav = {
  init: function() {
    var tog = document.getElementById('nav-tog');
    var drw = document.getElementById('nav-drw');
    var ovl = document.getElementById('nav-ovl');
    var cls = document.getElementById('nav-cls');
    if (!tog || !drw) return;
    function abrir()  { drw.removeAttribute('hidden'); if (ovl) ovl.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
    function fechar() { drw.setAttribute('hidden',''); if (ovl) ovl.setAttribute('hidden',''); document.body.style.overflow = ''; }
    tog.addEventListener('click', function() { drw.hasAttribute('hidden') ? abrir() : fechar(); });
    if (cls) cls.addEventListener('click', fechar);
    if (ovl) ovl.addEventListener('click', fechar);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') fechar(); });
  }
};

window.ZizCountdown = {
  init: function() {
    document.querySelectorAll('[data-cd]').forEach(function(el) {
      if (el.dataset.cdOk) return;
      el.dataset.cdOk = '1';

      var modo = el.dataset.cdModo || 'fixo';
      var alvo;

      if (modo === 'rolante') {
        // Evergreen window: persists per-section in this browser until it expires,
        // then a fresh window starts automatically. Feels "always urgent", never fake-looking days.
        var horas = parseFloat(el.dataset.cdHoras) || 4;
        var chave = 'ziz-cd-' + (el.dataset.cdId || 'default');
        var salvo = null;
        try { salvo = parseInt(localStorage.getItem(chave), 10); } catch (e) {}
        if (!salvo || isNaN(salvo) || salvo <= Date.now()) {
          salvo = Date.now() + (horas * 3600000);
          try { localStorage.setItem(chave, String(salvo)); } catch (e) {}
        }
        alvo = salvo;
      } else {
        alvo = new Date(el.dataset.cd).getTime();
      }

      var hhEl  = el.querySelector('[data-cd-h]');
      var mmEl  = el.querySelector('[data-cd-m]');
      var ssEl  = el.querySelector('[data-cd-s]');
      var vivo  = el.querySelector('[data-cd-vivo]');
      var morto = el.querySelector('[data-cd-morto]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var diff = alvo - Date.now();
        if (diff <= 0) {
          if (modo === 'rolante') {
            // Renew immediately so the timer never visibly "dies" for evergreen mode.
            el.dataset.cdOk = '';
            window.ZizCountdown.init();
            return;
          }
          if (vivo)  vivo.hidden  = true;
          if (morto) morto.hidden = false;
          return;
        }
        var totalH = Math.floor(diff / 3600000);
        if (hhEl) hhEl.textContent = pad(totalH);
        if (mmEl) mmEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (ssEl) ssEl.textContent = pad(Math.floor((diff % 60000)    / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  }
};

window.ZizQuickAdd = {
  init: function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-qa]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.dataset.qa;
      if (!id) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added';
        if (window.ZizCart) ZizCart.update();
        document.dispatchEvent(new CustomEvent('ziz:cart-updated'));
        if (window.ZizDrawer) ZizDrawer.open();
        setTimeout(function() { btn.disabled = false; btn.textContent = orig; }, 2000);
      })
      .catch(function() { btn.disabled = false; btn.textContent = orig; });
    });
  }
};

window.ZizBuyNow = {
  init: function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-buy-now]');
      if (!btn) return;
      var id = btn.dataset.buyNow;
      if (!id) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) { return r.json().then(function(err){ throw new Error(err.description || 'Add to cart failed'); }); }
        return r.json();
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = orig;
        alert('Could not add this item to your cart. Please try again.');
      });
    });
  }
};

window.ZizCart = {
  update: function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(c) {
        document.querySelectorAll('[data-cart-n]').forEach(function(el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
      });
  }
};

window.ZizBarras = {
  init: function() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.width = e.target.dataset.w;
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('[data-w]').forEach(function(el) { obs.observe(el); });
  }
};

window.ZizViewers = {
  init: function() {
    document.querySelectorAll('[data-viewers]').forEach(function(el) {
      var base = parseInt(el.dataset.viewers, 10) || 16;
      var cur  = base + Math.floor(Math.random() * 8);
      el.textContent = cur;
      setInterval(function() {
        cur = Math.max(8, Math.min(base + 14, cur + (Math.random() > 0.5 ? 1 : -1)));
        el.textContent = cur;
      }, Math.floor(Math.random() * 5000) + 4000);
    });
  }
};

window.ZizSalesNotif = {
  vendas: [
    { emoji: '💎', nome: 'Sophie R.', local: 'London',     produto: 'Lumiere Hoop Earrings', tempo: '2 min ago' },
    { emoji: '💍', nome: 'Hannah T.', local: 'Manchester', produto: 'Marquise Ring 2CT',      tempo: '5 min ago' },
    { emoji: '✨', nome: 'Claire B.', local: 'Edinburgh',  produto: 'Celeste Drop Earrings',  tempo: '8 min ago' },
    { emoji: '📿', nome: 'Emma W.',   local: 'Bristol',    produto: 'Lumiere Necklace',        tempo: '11 min ago' },
    { emoji: '💍', nome: 'Olivia S.', local: 'Birmingham', produto: 'Aurora Ring',             tempo: '14 min ago' },
    { emoji: '💎', nome: 'Isla M.',   local: 'Glasgow',    produto: 'Lumiere Hoop Earrings',  tempo: '18 min ago' },
    { emoji: '💍', nome: 'Grace K.',  local: 'Leeds',      produto: 'Marquise Ring 2CT',      tempo: '22 min ago' },
    { emoji: '📿', nome: 'Amelia J.', local: 'Cardiff',    produto: 'Lumiere Necklace',        tempo: '26 min ago' }
  ],
  idx: 0,
  mostrar: function() {
    var self = this;
    var bar  = document.getElementById('sales-notif');
    if (!bar) return;
    var v = self.vendas[self.idx % self.vendas.length];
    self.idx++;
    var avatar = bar.querySelector('.snb__avatar');
    var titulo = bar.querySelector('.snb__titulo');
    var sub    = bar.querySelector('.snb__sub');
    if (avatar) avatar.textContent = v.emoji;
    if (titulo) titulo.textContent = v.nome + ' from ' + v.local + ' purchased';
    if (sub)    sub.textContent    = v.produto + ' — ' + v.tempo;
    bar.classList.add('visivel');
    setTimeout(function() { bar.classList.remove('visivel'); }, 4500);
  },
  init: function() {
    var self = this;
    var bar  = document.getElementById('sales-notif');
    if (!bar) return;
    var fechar = bar.querySelector('.snb__fechar');
    if (fechar) fechar.addEventListener('click', function() { bar.classList.remove('visivel'); });
    setTimeout(function() {
      self.mostrar();
      setInterval(function() { self.mostrar(); }, 18000);
    }, 6000);
  }
};

window.ZizExitPopup = {
  mostrado: false,
  init: function() {
    var self  = this;
    var ovl   = document.getElementById('exit-popup-ovl');
    var popup = document.getElementById('exit-popup');
    if (!ovl || !popup) return;
    function abrir() {
      if (self.mostrado) return;
      if (sessionStorage.getItem('ziz-exit')) return;
      self.mostrado = true;
      ovl.classList.add('visivel');
      document.body.style.overflow = 'hidden';
    }
    function fechar() {
      ovl.classList.remove('visivel');
      document.body.style.overflow = '';
      sessionStorage.setItem('ziz-exit', '1');
    }
    document.addEventListener('mouseleave', function(e) { if (e.clientY < 20) abrir(); });
    window.addEventListener('popstate', abrir);
    var btnFechar = document.getElementById('exit-popup-fechar');
    var btnNao    = document.getElementById('exit-popup-nao');
    if (btnFechar) btnFechar.addEventListener('click', fechar);
    if (btnNao)    btnNao.addEventListener('click',    fechar);
    ovl.addEventListener('click', function(e) { if (e.target === ovl) fechar(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') fechar(); });
    var form = document.getElementById('exit-popup-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        if (input && input.value) {
          popup.innerHTML = '<div style="text-align:center;padding:20px"><p style="font-family:var(--serif);font-style:italic;font-size:22px;color:var(--pergaminho);margin-bottom:10px">Code sent to your inbox.</p><p style="font-size:13px;color:var(--p50)">Use code <strong style="color:var(--ouro)">ZIZARA10</strong> at checkout.</p></div>';
          setTimeout(fechar, 4000);
        }
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  ZizEntrega.init();
  ZizHeader.init();
  ZizNav.init();
  ZizCountdown.init();
  ZizQuickAdd.init();
  ZizBuyNow.init();
  ZizBarras.init();
  ZizViewers.init();
  ZizSalesNotif.init();
  ZizExitPopup.init();
  ZizCart.update();
});

document.addEventListener('shopify:section:load', function() {
  ZizEntrega.init();
  ZizCountdown.init();
  ZizBarras.init();
  ZizViewers.init();
});
